import { useState } from 'react';
import _get from 'lodash/get';
import useProfileCommonStore from '../use-profile-common-store';
import { urls } from '../../../utils/url-helper/index';
import { useProfileShareClassDocuments, useProfileFundNotification } from '../../../hooks/api';
import { FUND_TYPES } from '../../../stores/profile/get-fund-type';
import useModalVisibility from '../../../hooks/use-modal-visibility';

const usePageHeader = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  const isRetirePlus =
    commonState.fundType === FUND_TYPES.retirePlusPro ||
    commonState.fundType === FUND_TYPES.retirePlus;

  const isFdicInsuredProduct = commonState.fundType === FUND_TYPES.fdicInsuredBankProduct;

  const { isInvestModalVisible, handleClickInvestButton, handleCloseInvestModal } =
    useModalVisibility();
  let isExternalSite = false;
  const currentXid = commonState.xref.isLoaded ? commonState.xref.data.xid : undefined;

  const shareClassResult = useProfileShareClassDocuments({
    ...apiConfigBase,
    shouldLoad: !!currentXid && !isFdicInsuredProduct
  });

  const fundNotificationResult = useProfileFundNotification({
    ...apiConfigBase,
    symbol: _get(commonState, 'xref.data.symbol')
  });

  const dropdownShareClasses =
    shareClassResult.isLoaded && shareClassResult.data.shareClasses
      ? shareClassResult.data.shareClasses.map(({ name, xid }) => {
          return {
            name,
            url: currentXid === xid ? null : urls.pages.profile({ xid }),
            xid
          };
        })
      : null;

  const fundNotification =
    fundNotificationResult.isLoaded && fundNotificationResult.data?.notificationText
      ? fundNotificationResult.data?.notificationText
      : '';
  const selectedItem = dropdownShareClasses
    ? dropdownShareClasses.find(sc => apiConfigBase.xid === sc.xid)
    : null;

  const documents = [];

  if (
    shareClassResult.isLoaded &&
    (shareClassResult.data.prospectusUrl ||
      shareClassResult.data.factSheetUrl ||
      shareClassResult.data.factSheetUrlList)
  ) {
    if (shareClassResult.data.prospectusUrl) {
      documents.push({
        label: isRetirePlus ? 'Disclosure Document' : 'Prospectus',
        url: shareClassResult.data.prospectusUrl
      });
    }

    if (shareClassResult.data.factSheetUrl) {
      const originUrl = new URL(shareClassResult.data.factSheetUrl).origin.toLowerCase();
      isExternalSite = !originUrl.includes('tiaa');
    }

    if (shareClassResult.data.factSheetUrl || shareClassResult.data.factSheetUrlList) {
      documents.push({
        label: `Fact Sheet${shareClassResult.data.factSheetUrlList ? 's' : ''}`,
        url: shareClassResult.data.factSheetUrl,
        urlList: shareClassResult.data.factSheetUrlList
      });
    }
  }

  if (isFdicInsuredProduct) {
    documents.push({
      label: 'Terms & Conditions',
      url: 'https://www.tiaa.org/public/pdf/prospectuses/BanksTerms.pdf'
    });
  }

  // TIAA-12541, add Proxy Voting Link under document icon
  const votingLinkFundList = [
    FUND_TYPES.fdicInsuredBankProduct,
    FUND_TYPES.variableAnnuityCref,
    FUND_TYPES.variableAnnuityTiaaAccess
  ];
  if (
    (_get(commonState, 'auxiliary.data.isProprietaryFund') &&
      _get(commonState, 'fundType') === FUND_TYPES.mutualFund) ||
    votingLinkFundList.includes(_get(commonState, 'fundType'))
  ) {
    documents.push({
      label: 'Proxy Voting Records',
      url: 'https://vds.issgovernance.com/vds/#/MTIwODY=/'
    });
  }

  return {
    documents,
    dropdownShareClasses,
    fundNotification,
    isExternalSite,
    isInvestModalVisible,
    handleClickInvestButton,
    handleCloseInvestModal,
    selectedItem
  };
};

export default usePageHeader;
